import { List, fromJS } from 'immutable';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import { S_INT } from '@lba-dev/package.local-globals/services';

import api from './api';
import { loadUsers } from './actions/users';
import { fetch as fetchFournisseurs } from './actions/fournisseurs';
import { loadCounter } from './actions/counter';
import { loadConnectedUser } from './actions/connectedUser';
import { loadEquipes } from './actions/equipes';
import { loadPoints } from './actions/points';
import {
  cacheInitStart,
  cacheInitSuccess,
  cacheInitError
} from './actions/cache';
import {
  fetch as fetchNotifications,
  removeNotifications
} from './actions/notifications';
import { fetch as fetchProducts } from './actions/products';
import { fetch as fetchGrandComptes } from './actions/grandComptes';
import { fetch as fetchCombos } from './actions/combos';
import { fetch as fetchAnnulations } from './actions/annulations';
import { fetch as fetcConfig } from './actions/config';
import { fetch as fetchMetiersSteps } from './actions/metiersSteps';
import { fetch as fetchMetiersDevis } from './actions/metiersDevis';
import { fetch as fetchQuestions } from './actions/questions';
import { fetch as fetchSignals } from './actions/signals';
import { fetch as fetchConfCand } from './actions/confCand';
import { fetch as fetchConfProsp } from './actions/confProsp';
import { fetch as fetchRaisonsArchiveSst } from './actions/raisonsArchiveSst';
import store from './store';
import { openChatPanel } from './actions/chatPanel';
import notifSystem from './notifSystem';
import {
  RINGOVER_NEW_CLIENT_CALL,
  RINGOVER_CURRENT_CONTACT_CALL,
  RINGOVER_NEW_CLIENT_CALL_ENDED,
} from './utils/ringoverEvents';


const initConnectedUser = () =>
  api.users.get('me').then((res) => {
    const user = res.body().data();
    store.dispatch(loadConnectedUser(user));
  })

const initUsers = (store, socket) => {
  socket.on('update_users', (data) => {
    const { connectedUser } = store.getState();
    if (connectedUser && data === connectedUser._id) {
      initConnectedUser(data);
    }
  });
  return api.users.getAll({}).then((res) => {
    const users = res.body().map((e) => e.data());
    store.dispatch(loadUsers(users));
  });
};


const initCount = (store) => {
  api.counter.get('').then((res) => {
    store.dispatch(loadCounter(res.body().data()));
  });
};

export const initPoints = (store, user) => {
  if (user.service === S_INT) {
    api.points.getAll().then((res) => {
      store.dispatch(loadPoints(res.body().map((e) => e.data())));
    });
  }
};

const initCombos = (store, user) => {
  if (permit(user, { key: 'retrieveCombinations' })) {
    const update = () => {
      api.combos.getAll({
        limit: 500
      }).then((res) => {
        const combos = fromJS(res.body().map((e) => e.data()));
        store.dispatch(fetchCombos(combos));
      });
    };
    update();
  }
};

const initAnnulations = (store, socket, user) => {
  if (permit(user, { key: 'retrieveAnnulation' })) {
    const update = (data) => {
      store.dispatch(fetchAnnulations(data));
    };
    socket.on('annulations', update);
    api.annulations.getAll({
      limit: 200
    }).then((res) => {
      update(res.body().map((e) => e.data()));
    });
  }
};

const initProducts = (store) => {
  const update = () => {
    api.products.getAll({
      limit: 500
    }).then((res) => {
      const data = res.body().map((e) => e.data());
      store.dispatch(fetchProducts(fromJS(data)));
    });
  };
  update();
};


const initGrandCompte = (store, socket, user) => {
  if (permit(user, { key: 'retrieveGrandCompte' })) {
    const update = (data) => {
      const grandComptes = fromJS(data);
      store.dispatch(fetchGrandComptes(grandComptes));
    };
    socket.on('grandCompte', update);
    api.grandCompte.getAll({
      limit: 200
    }).then((res) => {
      const data = res.body().map((e) => e.data());
      update(data);
    });
  }
};

const initEquipes = (store, user) => {
  if (permit(user, { key: 'retrieveEquipe' })) {
    api
      .one('equipes', '')
      .get()
      .then((res) => {
        store.dispatch(loadEquipes(res.body().data()));
      });
  }
};

const initSignals = (store) => {
  const update = (data) => {
    const signals = fromJS(data);
    store.dispatch(fetchSignals(signals));
  };
  api.signals.getAll({
    limit: 200
  }).then((res) => {
    const data = res.body().map((e) => e.data());
    update(data);
  });
};

const initRaisonsArchiveSst = (store) => {
  const update = (data) => {
    const raisonsArchiveSst = fromJS(data);
    store.dispatch(fetchRaisonsArchiveSst(raisonsArchiveSst));
  };
  api.raisonsArchiveSst.getAll({
    limit: 200
  }).then((res) => {
    const data = res.body().map((e) => e.data());
    update(data);
  });
};

const initFournisseurs = (store) => {
  const update = (data) => {
    store.dispatch(fetchFournisseurs(data));
  };
  api.configFournisseurs.getAll({
    limit: 200
  }).then((res) => {
    const data = res.body().map((e) => e.data());
    update(data);
  });
};

const initConfCand = (store) => {
  const update = (data) => {
    const confCand = fromJS(data);
    store.dispatch(fetchConfCand(confCand));
  };
  api.confCand.getAll({
    limit: 200
  }).then((res) => {
    const data = res.body().map((e) => e.data());
    update(data);
  });
};

const initConfProsp = (store) => {
  const update = (data) => {
    const confProsp = fromJS(data);
    store.dispatch(fetchConfProsp(confProsp));
  };
  api.confProsp.getAll({
    limit: 200
  }).then((res) => {
    const data = res.body().map((e) => e.data());
    update(data);
  });
};

const initConfig = (store, socket) => {
  const update = (data) => {
    store.dispatch(fetcConfig(data));
  };
  socket.on('config', update);
  api.config.getAll({
    limit: 200
  }).then((res) => {
    update(res.body().map((e) => e.data()));
  });
};

const initSMetiersSteps = (store) => {
  const update = () => {
    api.metiersSteps.getAll({
      query: JSON.stringify({ ref: null }),
      limit: 500
    }).then((res) => {
      store.dispatch(fetchMetiersSteps(res.body().map((e) => e.data())));
    });
  };
  update();
};

const initSMetiersDevis = (store) => {
  const update = () => {
    api.metiersDevis.getAll({
      query: JSON.stringify({ ref: null }),
      limit: 500
    }).then((res) => {
      store.dispatch(fetchMetiersDevis(res.body().map((e) => e.data())));
    });
  };
  update();
};

const initQuestions = (store) => {
  const update = () => {
    api.questions.getAll({
      limit: 1000
    }).then((res) => {
      store.dispatch(fetchQuestions(res.body().map((e) => e.data())));
    });
  };
  update();
};
/*
 **  Initializes notifications in store and
 **  waits for notifications update from socket
 */

const initNotifications = (store, userId, ws) => {
  const update = (notification) => {
    if (notification && notification.type === 'sms') {
      const type =
        (notification.artisan && 'artisan') ||
        ((notification.devis || notification.intervention) && 'intervention');
      if (type) {
        store.dispatch(openChatPanel(null, type));
      }
    } else {
      notification.socket = true;
      store.dispatch(fetchNotifications(notification));
    }

  };

  const deleteNotif = ({ notificationDeleted }) => {
    const notifications = new List(
      store.getState().notifications.filter((e) =>
        !notificationDeleted.includes(e._id))
    );
    store.dispatch(removeNotifications(notifications));
  };

  if (!ws.socketV2) {
    return;
  }
  ws.socketV2.on('notifications', update);
  ws.socketV2.on('delete_notifications', deleteNotif);

  api
    .all(`notifications/${userId}/getUser`)
    .getAll({
      limit: 50
    })
    .then((res) => store.dispatch(
      fetchNotifications(new List(res.body().map((e) => e.data())))
    ));
};

const initRingover = (ws) => {
  if (!ws.socketV2) {
    return;
  }

  ws.socketV2.on('ringover', (event) => {
    switch (event.type) {
      case 'new_client_call':
        window.dispatchEvent(new CustomEvent(RINGOVER_NEW_CLIENT_CALL, {
          detail: { data: event.data }
        }));
        break;

      case 'current_contact_call':
        window.dispatchEvent(new CustomEvent(RINGOVER_CURRENT_CONTACT_CALL, {
          detail: { data: event.data }
        }));
        break;

      case 'new_client_call_ended':
        window.dispatchEvent(new CustomEvent(RINGOVER_NEW_CLIENT_CALL_ENDED, {
          detail: { data: event.data }
        }));
        break;

      default:
        break;
    }
  });
};

export const setCount = (key, value) => {
  const counter = store.getState().counter;
  counter[key] = value;
  store.dispatch(loadCounter({ ...counter }));
};

export default async function initCache(store, userId, ws, isChat) {
  store.dispatch(cacheInitStart());
  try {
    await Promise.all([
      initUsers(store, ws),
      initConnectedUser()
    ]);
    const user = store.getState().connectedUser;
    initNotifications(store, userId, ws);
    initRingover(ws);
    if (isChat) {
      if (user) {
        initSignals(store);
      }
    } else {
      if (user) {
        initCombos(store, user);
        initGrandCompte(store, ws, user);
        initSignals(store);
        initConfCand(store);
        initConfProsp(store);
        initAnnulations(store, ws, user);
        initEquipes(store, user);
        initFournisseurs(store);
        initPoints(store, user);
        initSMetiersSteps(store);
        initSMetiersDevis(store);
        initQuestions(store);
      }
      initCount(store);
      initProducts(store);
      initConfig(store, ws);
      initRaisonsArchiveSst(store);
    }

    store.dispatch(cacheInitSuccess());
  } catch (error) {
    store.dispatch(cacheInitError(error.message || error.toString()));
    notifSystem.error(error.name, error.message);
  }
}
